import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoaderService } from '../loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements AfterViewInit {
  loading$: Observable<boolean>;

  constructor(private loaderService: LoaderService, private cdr:ChangeDetectorRef) {
    this.loading$ = this.loaderService.loading$;
  }
  
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
}
